import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth as fbAuth } from "../firebase";

export default function ProtectedRoute({ children }) {
  // 1. Must have a stored token
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem("auth") || "null")?.token ?? null;
  } catch {
    token = null;
  }

  if (!token) return <Navigate to="/login" replace />;

  // 2. Wait for Firebase to finish restoring the session (currentUser is null
  //    for a brief moment on every page reload — don't redirect during that window)
  return <FirebaseAuthGuard>{children}</FirebaseAuthGuard>;
}

function FirebaseAuthGuard({ children }) {
  const [state, setState] = useState("loading"); // "loading" | "ok" | "redirect"

  useEffect(() => {
    // onAuthStateChanged fires once immediately when Firebase has resolved
    const unsub = fbAuth.onAuthStateChanged((fbUser) => {
      if (!fbUser) {
        setState("redirect");
        return;
      }

      const isEmailProvider = fbUser.providerData.some(
        (p) => p.providerId === "password"
      );
      if (isEmailProvider && !fbUser.emailVerified) {
        localStorage.removeItem("auth");
        localStorage.removeItem("isAuthed");
        setState("redirect");
        return;
      }

      setState("ok");
      unsub(); // stop listening after first resolution
    });

    return unsub;
  }, []);

  if (state === "loading") return null; // brief blank — no flash to login
  if (state === "redirect") return <Navigate to="/login" replace />;
  return children;
}
